var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 -8.74228e-07C4.47656 -1.3571e-06 1.3571e-06 4.47656 8.74228e-07 10C3.91354e-07 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 -3.91354e-07 10 -8.74228e-07ZM10 15C9.48047 15 9.0625 14.582 9.0625 14.0625L9.0625 9.6875C9.0625 9.16797 9.48047 8.75 10 8.75C10.5195 8.75 10.9375 9.16797 10.9375 9.6875L10.9375 14.0625C10.9375 14.582 10.5195 15 10 15ZM8.75 6.25C8.75 5.55859 9.3086 5 10 5C10.6914 5 11.25 5.55859 11.25 6.25C11.25 6.94141 10.6914 7.5 10 7.5C9.30859 7.5 8.75 6.94141 8.75 6.25Z",
    fill: "#2B6CEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.886b50c6151d237f7fd2b9d79a4b4035.svg";
export { ForwardRef as ReactComponent };